export default __webpack_public_path__ + "static/media/doc8.8d8821f8.jpeg";